class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');

        document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }

    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('mini-cart', MiniCart);

//  Progress bar 

function formatMoney(cents) {
  return `$${(cents / 100).toFixed(2)}`;
}

let isUpdating = false;

function initProgress() {
  if (isUpdating) return;

  const wrapper = document.querySelector('[data-cart-progress]');
  if (!wrapper) return;

  const subtotal = wrapper.dataset.progressSubtotal;
  if (!subtotal) return;

  isUpdating = true;

  const fill = wrapper.querySelector('[data-progress-fill]');
  const text = wrapper.querySelector('[data-progress-text]');
  const save = wrapper.querySelector('[data-progress-save]');
  const steps = [...wrapper.querySelectorAll('.cart-progress-step')];

  let currentTier = null;
  let nextTier = null;

  // Reset states
  steps.forEach(step => {
    step.classList.remove('active', 'completed');
  });

  // Determine tiers
  for (let i = 0; i < steps.length; i++) {
    const threshold = Number(steps[i].dataset.threshold);

    if (subtotal < threshold) {
      nextTier = {
        el: steps[i],
        threshold,
        discount: steps[i].dataset.discount
      };
      break;
    }

    currentTier = {
      el: steps[i],
      threshold,
      discount: steps[i].dataset.discount
    };
  }

  // Apply completed state
  steps.forEach(step => {
    const threshold = Number(step.dataset.threshold);
    if (subtotal >= threshold) {
      step.classList.add('completed');
    }
  });

  // Apply active state
  if (nextTier) {
    nextTier.el.classList.add('active');
  }

  // Progress calculation
  let progress = 100;

  if (nextTier) {
    const prevThreshold = currentTier ? currentTier.threshold : 0;

    const prevStep = currentTier ? currentTier.el : null;
    const nextStep = nextTier.el;

    const prevLeft = prevStep ? prevStep.offsetLeft : 0;
    const nextLeft = nextStep.offsetLeft;

    const range = nextTier.threshold - prevThreshold;
    const progressInRange = subtotal - prevThreshold;

    const ratio = progressInRange / range;

    const barWidth = wrapper.querySelector('.cart-progress-bar').offsetWidth;

    const prevPercent = (prevLeft / barWidth) * 100;
    const nextPercent = (nextLeft / barWidth) * 100;

    progress = prevPercent + (nextPercent - prevPercent) * ratio;
  }

  fill.style.width = Math.min(progress, 100) + "%";

  // Messaging
  if (!nextTier && currentTier) {
    text.innerHTML = `You've unlocked the maximum discount`;
  } else if (nextTier) {
    const diff = nextTier.threshold - subtotal;
    text.innerHTML = `You're <strong>${formatMoney(diff)}</strong> away from <strong>${nextTier.discount}</strong> off`;
  }

  // Savings calculation
  let savings = 0;

  if (currentTier && currentTier.discount) {
    const discountValue = parseFloat(currentTier.discount.replace('%', '')) || 0;
    savings = Math.round(subtotal * (discountValue / 100));
  }

  if (save) {
    save.innerHTML = savings > 0
      ? `<strong>${formatMoney(savings)}</strong> saved!`
      : '';
  }

  setTimeout(() => {
    isUpdating = false;
  }, 100);
}

// FREE PRODUCT MESSAGE BAR
(function () {
  var TIER1_CENTS = 70000;  // $700
  var TIER2_CENTS = 100000; // $1000

  function formatMoney(cents) {
    var dollars = Math.ceil(cents / 100);
    return '$' + dollars;
  }

  // function updateProgress(cartTotalCents) {
  //   var total = parseInt(cartTotalCents, 10);
  //   if (isNaN(total)) return;

  //   var fill   = document.getElementById('gp-fill');
  //   var badge1 = document.getElementById('gp-badge1');
  //   var badge2 = document.getElementById('gp-badge2');
  //   var msg    = document.getElementById('gp-msg');

  //   if (!fill || !badge1 || !badge2 || !msg) return;

  //   var pct = Math.min((total / TIER2_CENTS) * 100, 100);
  //   fill.style.width = pct + '%';

  //   if (total >= TIER2_CENTS) {
  //     badge1.classList.add('is-unlocked');
  //     badge2.classList.add('is-unlocked');
  //     msg.innerHTML = '🎉 You\'ve unlocked a <strong>Free Junior Pillow</strong> and <strong>Linen Set</strong>!';
  //   } else if (total >= TIER1_CENTS) {
  //     badge1.classList.add('is-unlocked');
  //     badge2.classList.remove('is-unlocked');
  //     msg.innerHTML = 'Spend <strong>' + formatMoney(TIER2_CENTS - total) + '</strong> more to unlock a <strong>Free Junior Pillow and Linen Set</strong>.';
  //   } else {
  //     badge1.classList.remove('is-unlocked');
  //     badge2.classList.remove('is-unlocked');
  //     msg.innerHTML = 'Spend <strong>' + formatMoney(TIER1_CENTS - total) + '</strong> more to unlock a <strong>Free Junior Pillow</strong>.';
  //   }
  // }

  function updateProgress(cartTotalCents) {
    var total = parseInt(cartTotalCents, 10);
    if (isNaN(total)) return;
  
    var fill = document.getElementById('gp-fill');
    var badge = document.getElementById('gp-badge2');
    var msg = document.getElementById('gp-msg');
  
    if (!fill || !badge || !msg) return;
  
    var pct = Math.min((total / TIER2_CENTS) * 100, 100);
    fill.style.width = pct + '%';
  
    if (total >= TIER2_CENTS) {
      badge.classList.add('is-unlocked');
      msg.innerHTML =
        '🎉 You\'ve unlocked a <strong>Free Linen Set</strong>!';
    } else {
      badge.classList.remove('is-unlocked');
      msg.innerHTML =
        'Spend <strong>' + formatMoney(TIER2_CENTS - total) + '</strong> more to unlock a <strong>Free Linen Set</strong>.';
    }
  }

  function fetchAndUpdate() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateProgress(cart.total_price); })
      .catch(function (e) { console.error('[gift-progress] cart fetch failed', e); });
  }

  // Run on initial page load
  fetchAndUpdate();

  // Re-run whenever Shopify cart drawer re-renders its sections
  // Works with Dawn and most modern themes
  document.addEventListener('cart:updated', fetchAndUpdate);
  document.addEventListener('cart:refresh', fetchAndUpdate);

  // Intercept native fetch calls to cart endpoints
  var _fetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    var isCartAction = /\/(cart\/(add|change|update|clear))(\.js)?/.test(url);

    var promise = _fetch.apply(window, args);

    if (isCartAction) {
      promise.then(function (response) {
        // Clone so the original response stream isn't consumed
        response.clone().json().then(function (data) {
          // Some endpoints return the cart directly
          if (data && typeof data.total_price !== 'undefined') {
            updateProgress(data.total_price);
          } else {
            // Otherwise re-fetch the cart
            fetchAndUpdate();
          }
        }).catch(fetchAndUpdate);
        return response;
      });
    }

    return promise;
  };

  // Also intercept XMLHttpRequest for older themes
  var _open = XMLHttpRequest.prototype.open;
  var _send = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this._gp_url = url;
    return _open.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    var url = this._gp_url || '';
    var isCartAction = /\/(cart\/(add|change|update|clear))(\.js)?/.test(url);
    if (isCartAction) {
      this.addEventListener('load', function () {
        try {
          var data = JSON.parse(this.responseText);
          if (data && typeof data.total_price !== 'undefined') {
            updateProgress(data.total_price);
          } else {
            fetchAndUpdate();
          }
        } catch (e) {
          fetchAndUpdate();
        }
      });
    }
    return _send.apply(this, arguments);
  };

  // Re-run when cart drawer opens (in case DOM wasn't ready earlier)
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-cart-toggle], [href="#cart-drawer"], .cart-icon-bubble, [aria-controls="CartDrawer"]');
    if (trigger) {
      setTimeout(fetchAndUpdate, 300);
    }
  });

  // Re-run whenever the cart drawer re-renders and injects fresh HTML
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var nodes = mutations[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        var node = nodes[j];
        if (node.nodeType === 1) {
          // Check if the progress bar is inside the added node
          if (node.id === 'gift-progress' || node.querySelector && node.querySelector('#gift-progress')) {
            fetchAndUpdate();
            return;
          }
        }
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();

/* -----------------------------
   SAFE EVENT HOOKS
----------------------------- */

// Initial load
// document.addEventListener('cartdrawer:opened', initProgress);

// Theme events (if available)
['cartdrawer:opened', 'cart:updated', 'cart:added', 'ajaxProduct:added'].forEach(event => {
  document.addEventListener(event, initProgress);
});